import { Expose } from "class-transformer";

export class CreateProjectHasCurrencyDto {
  @Expose()
  projectId: string;

  @Expose()
  currencyId: string;
}
